<template>
	<modal
		classe-personalizada-body="modal-orgaos-participantes"
		:exibir="exibir"
		titulo="Órgãos Participantes"
		@close="fecharModal"
		max-height="80%"
	>
		<template #body>
			<div class="mt-4">
				<h3>Participantes da Previsão de Consumo</h3>
				<v-data-table
					:headers="colunasOrgaosPrevConsumo"
					:items="orgaosParticipantesPrevConsumo"
					item-key="sigla"
					no-data-text="Não há participantes na previsão de consumo"
					:items-per-page="-1"
					hide-default-footer
					hide-default-header
				>
					<template #item.orgaosParticipantesPrevConsumo="{ item }">
						<span>{{ item.sigla }} - {{ item.nome }}</span>
					</template>
				</v-data-table>
			</div>

			<v-divider></v-divider>

			<div class="mt-4">
				<h3>Participantes Adesão</h3>
				<v-data-table
					:headers="colunasOrgaosAdesao"
					:items="orgaosParticipantesAdesao"
					item-key="sigla"
					no-data-text="Não há participantes na adesão"
					:items-per-page="-1"
					hide-default-footer
					hide-default-header
				>
					<template #item.orgaosParticipantesAdesao="{ item }">
						<span v-if="item.isExterno">
							<icone-tooltip
								icone="mdi-file-import-outline"
								cor="primary"
								texto="Adesão Pública"
								tamanho="20px"
							></icone-tooltip>
							{{ item.nome }} ({{ filtroMascaraCnpj(item.cnpj) }})
						</span>
						<span v-else>{{ item.sigla }} - {{ item.nome }}</span>
					</template>
				</v-data-table>
			</div>
		</template>
	</modal>
</template>
Agen
<script>
import Modal from '@/views/components/Modal.vue'
import { TabelaColunaUtils } from '@/core/utils'
import IconeTooltip from '@/views/components/IconeTooltip.vue'
import { actionTypes } from '@/core/constants'

export default {
	name: 'modal-orgaos-participantes',
	components: { IconeTooltip, Modal },
	props: {
		exibir: {
			type: Boolean,
		},
		idAta: {
			type: Number,
			required: true,
		},
	},
	data() {
		return {
			colunasOrgaosPrevConsumo: [
				new TabelaColunaUtils('Participantes da Previsão de Consumo', 'orgaosParticipantesPrevConsumo'),
			],
			orgaosParticipantesPrevConsumo: [],
			colunasOrgaosAdesao: [new TabelaColunaUtils('Participantes Adesão', 'orgaosParticipantesAdesao')],
			orgaosParticipantesAdesao: [],
			filtroMascaraCnpj: this.$options.filters.azCpfCnpj,
		}
	},
	async mounted() {
		await this.buscarOrgaosParticipantesDaAta()
	},
	methods: {
		async buscarOrgaosParticipantesDaAta() {
			const data = await this.$store.dispatch(actionTypes.ATA.BUSCAR_ORGAOS_PARTICIPANTES, this.idAta)

			this.orgaosParticipantesPrevConsumo = data.orgaosParticipantesPrevConsumo
			this.orgaosParticipantesAdesao = data.orgaosParticipantesAdesao
		},
		fecharModal() {
			this.$emit('fechar-modal')
		},
	},
}
</script>

<style lang="stylus">
.modal-orgaos-participantes
	max-height 500px
</style>
